import { toast } from 'react-toastify';

// Custom
export const notifyActionSuccess = (action: string) => {
    const capitalized = action.charAt(0).toUpperCase() + action.slice(1);
    toast(`${capitalized} successfully.`);
};

export const notifyAPIClient = (apiClientMessage: string) => {
    toast(`${apiClientMessage}`);
};

// Pre-defined
export const notifySuccess = () => toast('Successfully!');

export const notifyFailure = () => toast('Something went wrong.');